import { LuLayers, LuPackage, LuSlidersHorizontal } from "react-icons/lu";
import { CollectionSummary } from "../../../../components/collectionTools";
import { TableLayout } from "../../layouts/table";
import { Edition } from "./edition";
import { AttributeList } from "./attributeList";
import { getAttributeList } from "./attributeListModel";
import "./style.css";
export const Attributes = () => (
  <section className="catalogsReference attributesReference">
    <TableLayout
      title="Atributos"
      idKey="listId"
      addText="Nuevo atributo"
      edition={<Edition />}
      get={getAttributeList}
      identificator="attributes"
      renderSummary={(rows) => (
        <CollectionSummary
          items={[
            {
              label: "Atributos",
              icon: <LuSlidersHorizontal />,
              value: rows.length,
            },
            {
              label: "Variantes",
              icon: <LuLayers />,
              value: rows.filter((row) => row.type === "variant").length,
            },
            {
              label: "Productos con atributos",
              icon: <LuPackage />,
              value: "—",
              detail: "Recuento no disponible en este listado",
            },
          ]}
        />
      )}
      renderContent={(rows, onEdit) => (
        <AttributeList rows={rows} onEdit={onEdit} />
      )}
    />
  </section>
);
